import { useState } from "react";
import { back } from "../Api/ApiUrl";
import instance from "../Api/Instance";

export default function usePostalCode() {
  const getPostalCodeInfo = async (postalCode) => {
    try {
      const response = await instance.get(
        `${back.getPostalCode}/${postalCode}`
      );

      if (response.status === 200) {
        return response.data;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const getPostalCodeRestriction = async (postalCode) => {
    try {
      const response = await instance.get(back.getPostalCodeRestriction, {
        params: {
          originpc: postalCode,
        },
      });

      if (response.status === 200) {
        return response.data;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return {
    getPostalCodeInfo,
    getPostalCodeRestriction,
  };
}
